import {forwardRef, type HTMLProps} from 'react';

import classNames from 'classnames';

import styles from './TextArea.module.css';

interface Props extends HTMLProps<HTMLTextAreaElement> {
  error?: string;
  id?: string;
  label?: string;
}

const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({disabled, error, id, label, ...rest}, ref) => {
    id = id || Math.random().toString(36).substring(2);

    return (
      <div
        className={classNames(
          'TextArea',
          styles.TextArea,
          disabled && styles.disabled,
        )}
      >
        <textarea {...rest} disabled={disabled} id={id} ref={ref} />
        {label ? <label htmlFor={id}>{label}</label> : null}
        <span className={styles.error}>{error}</span>
      </div>
    );
  },
);

export default TextArea;
